import React from 'react';

const CampaignFooter = () => (
  <footer className="ff-footer" data-testid="ff-footer">
    <div className="ff-container">
      <h4>The Lokal</h4>
      <p className="ff-footer-tag">Experience the Art of Winemaking</p>
      <p style={{ margin: '0 0 12px' }}>Fenelon Falls, Ontario</p>
      <div>
        <a href="https://thelokal.ca/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy</a>
        <a href="https://thelokal.ca/privacy-policy#terms" target="_blank" rel="noopener noreferrer">Promotional Terms</a>
        <a href="https://thelokal.ca/#accessibility" target="_blank" rel="noopener noreferrer">Accessibility</a>
        <a href="mailto:info@thelokal.ca">Contact</a>
        <a href="https://thelokal.ca" target="_blank" rel="noopener noreferrer">Main Website</a>
      </div>
      <p className="ff-legal">
        You must be 19 years of age or older to participate. Promotional eligibility is subject to confirmation.
        Offers may not be combined unless expressly stated. Please enjoy responsibly.
      </p>
    </div>
  </footer>
);

export default CampaignFooter;
